
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"80","height":"80","rx":"5","fill":"#C7C7C7"}}),_c('path',{attrs:{"d":"M48.442 32.497l-2.14-5.246c-.284-.568-.712-.851-1.283-.851H34.181c-.57 0-1.14.284-1.283.85l-2.14 5.247c-.285.568-.855.851-1.426.851h-4.706c-.855 0-1.426.567-1.426 1.418v17.016c0 .85.57 1.418 1.426 1.418h29.948c.856 0 1.426-.567 1.426-1.418V34.766c0-.85-.57-1.418-1.426-1.418h-4.706c-.57 0-1.14-.283-1.426-.85z","stroke":"#fff","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M39.6 48.946c4.332 0 7.844-3.492 7.844-7.799s-3.512-7.799-7.844-7.799c-4.331 0-7.843 3.492-7.843 7.8 0 4.306 3.512 7.798 7.843 7.798z","stroke":"#fff","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    